import { render } from "./show.vue?vue&type=template&id=7b5249cc&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "./show.vue?vue&type=style&index=0&id=7b5249cc&lang=scss&scoped=true"
import "./show.vue?vue&type=style&index=1&id=7b5249cc&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5249cc"]])

export default __exports__